<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseRewards"
  backButtonText="Back"
  [backSwipe]="backSwipeConfig"
  (click)="back.emit()"
/>
